module.exports = __webpack_public_path__ + "media/02migration.73adc7fb.mp3";